export enum RedoneStatus {
  NoReason = 0,
  ManufacturingDefect = 1,
  ShadeMissmatchDefect = 2,
  ImpressionDefect = 3,
  FittingDefect = 4,
  ProtocolComplianceDefect = 5,
  OcclusionDefect = 6,
  ProsthesisLoss = 7,
}
